import { useStyletron } from "baseui";
import { StyledSvg } from "baseui/icon";
import React from "react";

export const WarningCircleIcon = (props: React.ComponentProps<typeof StyledSvg> & { $disabled: boolean }) => {
  const [_css, $theme] = useStyletron();

  return (
    <StyledSvg viewBox="0 0 16 16" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99998 1.60001C4.46558 1.60001 1.59998 4.46561 1.59998 8.00001C1.59998 11.5344 4.46558 14.4 7.99998 14.4C11.5344 14.4 14.4 11.5344 14.4 8.00001C14.4 4.46561 11.5344 1.60001 7.99998 1.60001ZM8.64638 4.26667L8.53971 9.06667H7.46024L7.35358 4.26667H8.64638ZM8.00158 11.8341C7.55998 11.8341 7.29598 11.5989 7.29598 11.2037C7.29598 10.8011 7.55944 10.5659 8.00158 10.5659C8.43998 10.5659 8.70344 10.8011 8.70344 11.2037C8.70344 11.5989 8.43998 11.8341 8.00158 11.8341Z"
        fill={props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow600)}
      />
    </StyledSvg>
  );
};
